import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  setToken: (token: string | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: !!localStorage.getItem('jwt_token'),
      token: localStorage.getItem('jwt_token'),
      setToken: (token: string | null) => {
        if (token) {
          localStorage.setItem('jwt_token', token);
          set({ token, isAuthenticated: true });
        } else {
          localStorage.removeItem('jwt_token');
          set({ token: null, isAuthenticated: false });
        }
      },
      logout: () => {
        localStorage.removeItem('jwt_token');
        // Clear any other auth-related data from localStorage if needed
        localStorage.removeItem('user_language');
        set({ token: null, isAuthenticated: false });
        // Redirect to login page
        window.location.href = '/login';
      },
    }),
    {
      name: 'auth-storage',
      version: 1,
      partialize: (state) => ({ isAuthenticated: state.isAuthenticated }),
    }
  )
); 